import { TextAreaInput } from '@framework/form/inputs/TextAreaInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { CommonContainerWidgetConfigSchema } from '../common/CommonContainerWidgetConfigSchema.ts';
import { type IColumnWidget } from './IColumnWidget.ts';

export const ColumnWidgetConfigSchema: yup.ObjectSchema<IColumnWidget> =
  CommonContainerWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Column).required(),
    notes: yup.string().notRequired().label('Note'),
  });

type IColumnWidgetConfigComponentProps = IWidgetComponentProps<IColumnWidget>;

export function ColumnWidgetConfigComponent(
  props: IColumnWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);
  return (
    <>
      <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />
      <FormItem
        name="notes"
        label="Note del configuratore"
        help="Questo campo sarà visibile solo in fase di configurazione."
      >
        <TextAreaInput name={'notes'} rows={3} />
      </FormItem>
    </>
  );
}
